"use strict";
import largeStyles from "../src/spectrum-two/scale-large.css.js";
import { Theme } from "../src/Theme.dev.js";
import "../src/spectrum-two/core.dev.js";
Theme.registerThemeFragment("large-spectrum-two", "scale", largeStyles);
//# sourceMappingURL=scale-large.dev.js.map
